import React from 'react';
import { LayersIcon, FileTextIcon, RepeatIcon, ZapIcon, RefreshCwIcon } from 'lucide-react';
import { featureHighlights, features } from '../data/content';
import { SectionHeading } from './SectionHeading';
const icons = [LayersIcon, FileTextIcon, RepeatIcon, ZapIcon, RefreshCwIcon];
export function WhatYouGet() {
  return <section aria-labelledby="get-title" className="bg-paper" data-id="element-367" data-mp="q37kiv0tarf9">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 lg:py-28" data-id="element-368" data-mp="1drgzbczlyeww">
        <SectionHeading id="get-title" title="Everything You Need to Start Sharing" intro="With the Gospel Sharing Mega Bundle, you’ll receive instant digital access to:" data-id="element-369" data-mp="1duczz92ubhp1" />
        <div className="mt-14 grid gap-5 md:grid-cols-2" data-id="element-370" data-mp="191aapd53iuen">
          {featureHighlights.map(f => <div key={f.title} className="flex flex-col rounded-[28px] bg-cream p-8 sm:p-10" data-id="element-371" data-mp="1wr4qa2gsux2l">
              <span className="font-display text-[80px] leading-[0.85] text-coral" data-id="element-372" data-mp="21hl5ns46ksrl">{f.value}</span>
              <h3 className="mt-4 text-xl font-extrabold uppercase tracking-[0.08em] text-navy" data-id="element-373" data-mp="2vftzk3mrf1ij">{f.title}</h3>
              <p className="mt-3 leading-relaxed text-ink-soft" data-id="element-374" data-mp="2qgzcgphreqsm">{f.text}</p>
            </div>)}
        </div>
        <ul className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-5" data-id="element-375" data-mp="355voexmxsnyi">
          {features.map((f, i) => {
          const Icon = icons[i];
          return <li key={f.title} data-id="element-376" data-mp="3e6bpk0g7jj07" data-mpi={i}>
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-leaf-wash text-leaf-deep" data-id="element-377" data-mp="3e5aazlzzgedq">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-378" data-mp="396p7ndpfpel2" />
                </span>
                <h3 className="mt-4 font-extrabold uppercase tracking-[0.06em] text-navy" data-id="element-379" data-mp="3o36kk9d9v19q">{f.title}</h3>
                <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-380" data-mp="3j6pv9buc6gv2">
                  {f.text}
                  {f.strong && <strong className="font-bold text-navy" data-id="element-381" data-mp="1tr0691p304d7"> {f.strong}</strong>}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}